import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: '../views/footer.component.html',
  styleUrls: ['../css/footer.component.css']
})
export class FooterComponent implements OnInit {
  public year
  constructor() { }

  ngOnInit() {
       var d = new Date();
  this.year = d.getFullYear();
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/housekeeping/components/footer.component.ts